import Lista from './Lista';

export const EmprestimoUniformeLista = Lista;
